import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import { param } from '@/redux/selectors/uiSelectors.js';
import { companyId as companyIdSelector } from '@/redux/selectors/userSelectors.js';
import workflowScreenSelectors from '@/screens/workflows/redux/selectors/workflowScreenSelectors.js';
import routes from '@/routes.js';
import { useSelector } from 'react-redux';

const usePresenceId = () => {
  const appId = useArgSelector(param, 'appId');
  const appVersion = useArgSelector(param, 'appId');
  const workflowId = useArgSelector(param, 'workflowId');
  const jobId = useArgSelector(param, 'jobId');

  // Presence channels are company-scoped so the pusher auth endpoint can verify the
  // caller owns the channel (see canAccessPresenceChannel). Workflows are tagged with
  // the workflow's own company via activeWorkflow — for an admin that differs from
  // their active company, keeping admins and the owning company's users on one channel
  // (activeWorkflow resolves cross-company workflows for the Admin role). Jobs,
  // monitoring, and settings are always loaded scoped to the active company, so the
  // active company is the owner there.
  const activeCompanyId = useSelector(companyIdSelector);
  const workflowCompanyId = useSelector((state) => workflowScreenSelectors.activeWorkflow(state)?.companyId);

  const activeRouteId = useSelector((state) => state.ui.activeRouteId);
  const activeRouteSlug = routes.find((n) => n.id === activeRouteId)?.routeId;

  let presenceId = null;

  if (activeRouteSlug === 'jobs' && jobId) {
    presenceId = activeCompanyId ? `${activeRouteSlug}-${jobId}-${activeCompanyId}` : null;
  }

  if (activeRouteSlug === 'apps' && appId && appVersion !== undefined) {
    presenceId = `${activeRouteSlug}-${appId}-${appVersion}`;
  }

  if (activeRouteSlug === 'workflows' && workflowId) {
    const ownerCompanyId = workflowCompanyId || activeCompanyId;
    presenceId = ownerCompanyId ? `${activeRouteSlug}-${workflowId}-${ownerCompanyId}` : null;
  }

  if (activeRouteSlug === 'monitoring') {
    presenceId = activeCompanyId ? `${activeRouteSlug}-${activeCompanyId}` : null;
  }

  if (activeRouteSlug === 'settings') {
    presenceId = activeCompanyId ? `${activeRouteSlug}-${activeCompanyId}` : null;
  }

  return presenceId;
};

export default usePresenceId;
